import { render, staticRenderFns } from "./ModalCreationCommande.vue?vue&type=template&id=8b8ec660&"
import script from "./ModalCreationCommande.vue?vue&type=script&lang=js&"
export * from "./ModalCreationCommande.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b8ec660')) {
      api.createRecord('8b8ec660', component.options)
    } else {
      api.reload('8b8ec660', component.options)
    }
    module.hot.accept("./ModalCreationCommande.vue?vue&type=template&id=8b8ec660&", function () {
      api.rerender('8b8ec660', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Commandes/ModalCreationCommande.vue"
export default component.exports